import './index.css';

import * as React from 'react';
import { connect } from 'react-redux';
import Constants from 'src/common/Constants';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Note from 'src/entities/Note';

import {
  createNote,
  destroyNote,
  readNotesByGroup,
  updateNote
} from '../../actions/note';
import PlusWhite from '../../res/img/plus_white.svg';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';
import NoteCreate from './create';
import NoteItem from './item';

interface IProps {
  group: Group;
  account: Member;
  notes: Note[];
  members: Member[];
  createNote: (note: Note) => void;
  updateNote: (note: Note) => void;
  destroyNote: (note: Note) => void;
  readNotesByGroup: (group: Group) => void;
}

interface IState {
  doesShowNewNoteForm: boolean;
  loadedApis: number[];
}

class NoteComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      doesShowNewNoteForm: false,
      loadedApis: []
    };

    this.showNewNoteForm = this.showNewNoteForm.bind(this);
    this.hideNewNoteForm = this.hideNewNoteForm.bind(this);
  }

  componentWillMount() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readNotesByGroup(this.props.group);
    }
  }

  componentDidUpdate() {
    if (
      this.props.group !== undefined &&
      !this.state.loadedApis.includes(this.props.group.id)
    ) {
      this.setState({
        loadedApis: [...this.state.loadedApis, this.props.group.id]
      });
      this.props.readNotesByGroup(this.props.group);
    }
  }

  render() {
    if (this.props.group === undefined) {
      return null;
    }

    if (!this.props.group.functions.includes(Constants.FUNCTION_NOTE)) {
      return (
        <div id="NoteIndex">
          {this.renderHeader()}
          <div id="FunctionNotFound">
            ノート機能は本グループで無効になっています。
          </div>
        </div>
      );
    }

    return (
      <div id="NoteIndex">
        {this.renderHeader()}

        <div id="Notes">
          {this.state.doesShowNewNoteForm ? (
            <NoteCreate
              hideNewNoteForm={this.hideNewNoteForm}
              createNote={this.props.createNote}
              account={this.props.account}
              members={this.props.members.filter(member =>
                this.props.group.members.includes(member.id)
              )}
              group={this.props.group}
            />
          ) : null}

          {this.props.notes.length ? (
            <div>
              {this.props.notes
                .sort((a, b) => (a.created < b.created ? 1 : -1))
                .map(note => (
                  <NoteItem
                    key={note.id}
                    note={note}
                    members={this.props.members.filter(member =>
                      this.props.group.members.includes(member.id)
                    )}
                    group={this.props.group}
                    account={this.props.account}
                    updateNote={this.props.updateNote}
                    destroyNote={this.props.destroyNote}
                  />
                ))}
            </div>
          ) : (
            <div id="NoNote">ノートがありません</div>
          )}
        </div>

        {this.props.group.admins.includes(this.props.account.id) &&
        !this.state.doesShowNewNoteForm ? (
          <div
            id="TriggerNewNote"
            onMouseUp={this.showNewNoteForm}
            onTouchEnd={this.showNewNoteForm}
          >
            <img src={PlusWhite} />
          </div>
        ) : null}
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="note" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>
      </div>
    );
  }

  showNewNoteForm() {
    this.setState({
      doesShowNewNoteForm: true
    });
  }

  hideNewNoteForm() {
    this.setState({
      doesShowNewNoteForm: false
    });
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  ),
  account: state.Account,
  members: state.Member,
  notes: state.Note.filter(
    (note: Note) =>
      note.groupId ===
      state.Group.find(
        (group: Group) => group.title === ownProps.match.params.group
      ).id
  ),
  t: Date.now()
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    createNote(note: Note) {
      dispatch(createNote(note));
    },
    updateNote(note: Note) {
      dispatch(updateNote(note));
    },
    destroyNote(note: Note) {
      dispatch(destroyNote(note));
    },
    readNotesByGroup(group: Group) {
      dispatch(readNotesByGroup(group));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoteComponent);



// WEBPACK FOOTER //
// ./src/components/Note/index.tsx